import type { ParentOption } from '../store/schema/CompositePickerInterfaces';
import type CompositePickerStore from '../store/schema/CompositePickerStore';
import { action } from 'satcheljs';

export const addParentOptions = action(
    'addParentOptions',
    (viewState: CompositePickerStore, parentOptions: ParentOption[]) => ({
        viewState,
        parentOptions,
    })
);
